import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Delete, Check } from "@material-ui/icons";
import axios from "axios";

export default class ComputeOt extends Component {
  constructor(props) {
    super();
    this.state = {
      showComputeModal: false,
      disableCompute: false,
    };
    this.handleshowComputeModal = this.handleshowComputeModal.bind(this);
  }

  handleshowComputeModal = (e) => {
    this.setState({ showComputeModal: !this.state.showComputeModal });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableCompute: true });
    axios.get("api/compute_overtime/" + this.props.id).then((res) => {
      this.props.parentCallback(true);
      this.setState({ showComputeModal: false });
      this.setState({ disableCompute: false });
    });
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-success btn-sm float-right"
          title="Compute OT"
          onClick={this.handleshowComputeModal}
        >
          <Check />
        </button>
        <Modal
          size="md"
          show={this.state.showComputeModal}
          onHide={() =>
            this.setState({ showComputeModal: !this.state.showComputeModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Compute Overtime:<br/>{this.props.name}<br/>{this.props.period}</h4>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSubmit} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Are you sure to compute overtime?</label>
                </div>
              </div>

              <div className="float-right">
                <button
                  disabled={this.state.disableCompute}
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                >
                  Compute
                </button>
                <button
                  onClick={this.handleshowDeleteModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
